module.exports = __webpack_public_path__ + "img/icon-pse.56561490.png";